import { initializeApp } from "firebase/app";
import { getMessaging, isSupported, Messaging } from "firebase/messaging";

import { firebaseConfig, firebaseVapidKey } from "./configuration";

export const firebaseApp = initializeApp(firebaseConfig);

const firebaseServiceWorkerParameters = new URLSearchParams({
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  messagingSenderId: firebaseConfig.messagingSenderId,
  appId: firebaseConfig.appId
});

export const firebaseServiceWorkerUrl = `/firebase-messaging-sw.js?${firebaseServiceWorkerParameters.toString()}`;

export { firebaseVapidKey };

export const getFirebaseMessaging = async (): Promise<Messaging | null> => {
  const messagingSupported = await isSupported();

  if (!messagingSupported) {
    console.warn("Firebase Messaging is not supported by this browser.");

    return null;
  }

  return getMessaging(firebaseApp);
};
